var render, staticRenderFns
import script from "./BaseMn.vue?vue&type=script&lang=js&"
export * from "./BaseMn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0893a28",
  null
  
)

export default component.exports